import { Button, Grid } from '@mui/material';
import React from 'react';

import Text from 'commons/Text';

import useStyles from './styles';

const GridMainFeature1 = ({
  xsGridLeft,
  mdGridLeft,
  xsGridRight,
  mdGridRight,
  src1,
  textContent,
  textSubContent,
  textButton,
  gridStyle,
  textSubContent2,
  textSubContent3,
  textSubContent4,
}) => {
  const classes = useStyles();

  return (
    <Grid
      className={gridStyle}
      container
    >
      <Grid
        item
        xs={xsGridLeft}
        md={mdGridLeft}
      >
        <div className={classes.wrapImageMainFeature}>
          <img
            className={classes.mainFeature1}
            src={src1}
          />
        </div>
      </Grid>
      <Grid
        item
        xs={xsGridRight}
        md={mdGridRight}
      >
        <div className={classes.wrapDescription}>
          <Text className={classes.textContent}>{textContent}</Text>
          <Text className={classes.textSubContent}>{textSubContent}</Text>

          <Text className={classes.textSubContent2}>{textSubContent2}</Text>
          <Text className={classes.textSubContent2}>{textSubContent3}</Text>
          <Text className={classes.textSubContent2}>{textSubContent4}</Text>
          <Button
            variant="outlined"
            fullWidth
            className={classes.button}
          >
            <Text className={classes.textButton}>{textButton}</Text>
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default GridMainFeature1;
